import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { RadioSelect } from '../../index.js';
import THEME from '../../../theme.js';
import DraggableList from '../../DraggableList.js';
const OrderEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const { setOrderSettings } = props;
    const { byVoucherType, voucherTypeIdsOrdered, voucherCategoriesOrdered, voucherImposedBy, } = props.orderSettings;
    return (React.createElement("div", null,
        !props.readOnly && (React.createElement("div", null,
            React.createElement(RadioSelect, { onClick: () => setOrderSettings({
                    byVoucherType: false,
                }), active: !byVoucherType, label: lang.billingModels.byVoucherCategory }),
            React.createElement(RadioSelect, { onClick: () => setOrderSettings({
                    byVoucherType: true,
                }), active: byVoucherType, label: lang.billingModels.byVoucherType }),
            React.createElement("br", null),
            React.createElement("br", null))),
        byVoucherType ? (React.createElement(Ordering, null,
            React.createElement("h4", null, lang.tenants.voucherType),
            React.createElement(OrderingNumber, { theme: THEME.COLOR_GREY }, "1"),
            React.createElement(DraggableList, { list: voucherTypeIdsOrdered, onChange: (items) => setOrderSettings({
                    voucherTypeIdsOrdered: items,
                }), readOnly: props.readOnly }))) : (React.createElement(Ordering, null,
            React.createElement("h4", null, lang.tenants.voucherCategory),
            React.createElement(OrderingNumber, { theme: THEME.COLOR_GREY }, "1"),
            React.createElement(DraggableList, { list: voucherCategoriesOrdered, onChange: (items) => setOrderSettings({
                    voucherCategoriesOrdered: items,
                }), readOnly: props.readOnly }))),
        React.createElement(Ordering, null,
            React.createElement("h4", null, lang.tenants.voucherFrom),
            React.createElement(OrderingNumber, { theme: THEME.COLOR_GREY }, "2"),
            React.createElement(DraggableList, { list: voucherImposedBy, onChange: (items) => setOrderSettings({
                    voucherImposedBy: items,
                }), readOnly: props.readOnly }))));
};
const Ordering = styled.div `
  position: relative;
  background: #ffffff5a;
  margin-bottom: ${THEME.GRID_SPACING}px;
  border-radius: 3px;
  padding: ${THEME.GRID_SPACING}px;

  h4 {
    margin-top: 0;
  }
`;
const OrderingNumber = styled.div `
  position: absolute;
  top: -7px;
  left: -7px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: white;
  text-align: center;
  line-height: 1.9em;
  font-weight: 900;
`;
export default OrderEditor;
//# sourceMappingURL=OrderEditor.js.map